import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Auth } from '@data/users'
import type { IUser } from '@data/users/user'

interface UserState {
  user: IUser | null
  loading: boolean
  error: string | null
}

const initialState: UserState = {
  user: null,
  loading: false,
  error: null
}

export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
  const response = await Auth.getMe()

  return response.data
})

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: state => {
      state.user = null
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUser.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload
      })
      .addCase(fetchUser.rejected, (state, action) => {
        const message = action.error.message || ''

        const errorCode = message.split('.')[2]

        state.loading = false
        state.error = action.error.message || 'Failed to fetch user'
        Auth.handleLogout()

        switch (Number(errorCode)) {
          case 1012:
            window.location.href = '/cms/account-disable'
            break
          case 1020:
            window.location.href = '/cms/account-waiting-confirm'
            break
          case 1021:
            window.location.href = '/cms/account-block'
            break
          default:
            window.location.href = '/cms/login'
            break
        }
      })
  }
})

export const { clearUser } = userSlice.actions
export default userSlice.reducer
